export const API_USERAUTH_FETCH = 'api_userauth_fetch';
export const API_USERAUTH_SUCCESS = 'api_userauth_success';
export const API_USERAUTH_FAIL = 'api_userauth_success';

